import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MapsAPILoader, MouseEvent } from '@agm/core';

@Component({
  selector: 'app-manage-child-org-map',
  templateUrl: './manage-child-org-map.component.html',
  styleUrls: ['./manage-child-org-map.component.scss','../../platform-color/platform-color.scss']
})
export class ManageChildOrgMapComponent implements OnInit {
  markers: marker[] = [];

  lat: number = 13.764913;
  lng: number = 100.538283;
  zoom: number = 18;
  loadMap: boolean = false;
  loadSearch: boolean = false;

  @Output() done = new EventEmitter<any>();

  @ViewChild("closeModal", { static: true }) 
  closeModal: ElementRef;

  constructor(
    private spinner: NgxSpinnerService,

    private mapsAPILoader: MapsAPILoader,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.mapsAPILoader.load().then(async () => {
      let current = await this.getCurrentLocation({
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      })
      if(current){
        console.log('position:', current);

        this.lat = parseFloat(current['coords'].latitude.toFixed(6));
        this.lng = parseFloat(current['coords'].longitude.toFixed(6));

        this.loadMap = true;

        this.reset();
      }
    });
  }
  
  getCurrentLocation(options) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, ({code, message}) =>
        reject(Object.assign(new Error(message), {name: "PositionError", code})),
        options);
    });
  };

  mapClicked($event: MouseEvent) {
    this.markers = [];
    this.markers.push({
      lat: $event['coords'].lat,
      lng: $event['coords'].lng,
      draggable: true,
      icon: "assets/img/marker.png",
    });

    this.lat = parseFloat($event['coords'].lat.toFixed(6));
    this.lng = parseFloat($event['coords'].lng.toFixed(6));
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);

    this.lat = parseFloat($event['coords'].lat.toFixed(6));
    this.lng = parseFloat($event['coords'].lng.toFixed(6));
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      draggable: true
    });

    const search = document.getElementById("search") as HTMLElement;

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(search);

    const input = document.getElementById("search-input") as HTMLInputElement;

    const defaultBounds = {
      north: this.lat + 0.1,
      south: this.lat - 0.1,
      east: this.lng + 0.1,
      west: this.lng - 0.1,
    };

    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: "th" },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false,
      types: ["establishment"],
    };
  
    const autocomplete = new google.maps.places.Autocomplete(input, options);
  
    // Set initial restriction to the greater list of countries.
    autocomplete.setComponentRestrictions({
      country: ["th"],
    });

    autocomplete.addListener("place_changed", () => {

      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        //set latitude, longitude and zoom
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        this.zoom = 18;

        this.reset();
      });
    });
    setTimeout(() => {
      this.loadSearch = true;
      this.reset();
    }, 200);
  }

  reset(){
    this.cd.detectChanges();
  }

  save(){
    this.done.emit(
      {
        lat: this.lat,
        lng: this.lng
      }
    );
    this.closeModal.nativeElement.click();
  }

  close(){
    this.done.emit(false);
    this.reset();
  }
}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
  icon?: string;
}
